import { memo } from 'react';
import styled, { css } from 'foundations-theming/utils';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { CampaignOptionLabel } from './CampaignOptionLabel';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxOptionWrapper = styled.div.withConfig({
  displayName: "CampaignsPlatformSelectItem__CheckboxOptionWrapper"
})(["", ""], ({
  theme
}) => css(["label{padding-inline:", ";padding-block:", ";}"], theme.space['100'], theme.space['300']));
const CampaignsPlatformSelectItemBase = ({
  option,
  isSelected,
  isOneToMany,
  onToggle
}) => {
  var _option$value2;
  if (option.isSpecial || option.options || option.buttonText) {
    var _option$colorHex;
    return /*#__PURE__*/_jsx("div", {
      title: option.buttonText,
      children: /*#__PURE__*/_jsx(Flex, {
        paddingBlock: "200",
        paddingInline: "400",
        children: /*#__PURE__*/_jsx(CampaignOptionLabel, {
          text: option.buttonText || option.text || '',
          color: (_option$colorHex = option.colorHex) !== null && _option$colorHex !== void 0 ? _option$colorHex : undefined
        })
      })
    });
  }
  if (!isOneToMany) {
    var _option$value;
    return /*#__PURE__*/_jsx(Flex, {
      paddingBlock: "200",
      paddingInline: "400",
      "data-option-value": (_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : '',
      children: /*#__PURE__*/_jsx(CampaignOptionLabel, {
        text: option.text || option.buttonText,
        color: option.colorHex
      })
    });
  }
  return /*#__PURE__*/_jsx(CheckboxOptionWrapper, {
    "data-option-value": (_option$value2 = option.value) !== null && _option$value2 !== void 0 ? _option$value2 : '',
    children: /*#__PURE__*/_jsx(Checkbox, {
      checked: isSelected,
      onChange: onToggle,
      innerPadding: "none",
      children: /*#__PURE__*/_jsx(CampaignOptionLabel, {
        text: option.text,
        color: option.colorHex
      })
    })
  });
};
export const CampaignsPlatformSelectItem = /*#__PURE__*/memo(CampaignsPlatformSelectItemBase);